module.exports = __webpack_public_path__ + "static/media/oxipit.a961052b.png";